/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';

// local imports
import { CustomerService } from 'app/services';
import useDataApi from '../../use-data-api';
import { FormatUtils, TableUtils } from 'app/utils';

const useCustomerListService = (queries, isFilteringRef) => {
  const [service, setService] = useDataApi();
  const history = useHistory();

  // userDetail cell click
  const clickToDetail = id => {
    history.push({
      pathname: `/customer-management/${id}/customer-detail`,
      state: { id }
    });
  };

  const fetchData = useCallback(async () => {
    const customerList = await CustomerService.getCustomerList(queries);
    const customers = customerList.data.data;

    const out = customers?.map(item => {
      const { id, telephone, ...rest } = item;
      return {
        ...rest,
        id,
        telephone: FormatUtils.formatPhoneNumber(telephone),
        clickEvent: () => clickToDetail(id)
      };
    });

    isFilteringRef.current = false;

    return {
      table: {
        columns: TableUtils.customerList,
        rows: out
      },
      totalCount: customerList?.data?.total_count,
      total: Math.round(customerList?.data?.total_count / parseInt(queries.limit))
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [setService, fetchData]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useCustomerListService;
